
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

import { seenatlasService } from "../service";
import { SADownloadAsset, SAStammdatenBase } from "../interfaces";
import Gallery, { ResourceMeta } from "@/components/Gallery.vue";

import ErrorDialog from "@/components/ErrorDialog.vue";

@Component({
  components: {
    ErrorDialog,
    Gallery
  }
})
export default class Download extends Vue {
  @Prop()
  id!: string; // ist eigentlich die see_nr

  $refs!: {
    startDateMenu: HTMLFormElement;
    startPicker: HTMLFormElement;
    endDateMenu: HTMLFormElement;
    endPicker: HTMLFormElement;
  };

  stammdaten: SAStammdatenBase | null = null;
  downloadAssets: Array<SADownloadAsset> | null = null;

  messstellen: number[] = [];
  selectedMessstelle: number | null = null;

  startDateMenu = false;
  startDate: string | null = null;
  endDateMenu = false;
  endDate: string | null = null;
  excelDownloadIsValid = false;

  imageResourceMeta: ResourceMeta = {
    application: "seenatlas",
    resource: "foto",
    id: this.id
  };

  selectedAssets = [];

  get assetDownloadIsValid() {
    return this.stammdaten && this.selectedAssets.length;
  }

  beforeMount() {
    this.getSAStammdaten(this.id);
    this.getSADownloadAsset(this.id);
    this.getMessstellen(this.id);
  }

  getSAStammdaten(id: string) {
    seenatlasService
      .getSAStammdatenBase(id)
      .then(response => {
        this.stammdaten = response.data[0];
      })
      .catch(e => {
        console.error(e);
      });
  }

  getSADownloadAsset(id: string) {
    seenatlasService
      .getSADownloadAsset(id)
      .then(response => {
        this.downloadAssets = response.data;
      })
      .catch(e => {
        console.error(e);
      });
  }

  getMessstellen(id: string) {
    seenatlasService
      .getSAFachinformationMessstellen(id)
      .then(response => {
        response.data.forEach(messstelle => {
          this.messstellen.push(messstelle.messst_nr);
        });
      })
      .catch(e => {
        console.error(e);
      });
  }

  onDownloadAssets() {
    const stammdaten = this.stammdaten;
    if (!stammdaten) {
      return;
    }
    const params = new URLSearchParams();
    this.selectedAssets.forEach(da => params.append("id", da));
    window.open(
      process.env.VUE_APP_BASE_URL +
        "/seenatlas/download/" +
        stammdaten.id +
        "/" +
        stammdaten.see_bez.replace("/", " ") +
        ".zip" +
        "?" +
        params.toString()
    );
  }

  @Watch("startDateMenu")
  onStartMenuChanged(val) {
    val && setTimeout(() => (this.$refs.startPicker.activePicker = "YEAR"));
  }

  @Watch("endDateMenu")
  onEndMenuChanged(val) {
    val && setTimeout(() => (this.$refs.endPicker.activePicker = "YEAR"));
  }

  saveStartDate(date) {
    this.$refs.startDateMenu.save(date);
    this.startDate = date;
  }

  saveEndDate(date) {
    this.$refs.endDateMenu.save(date);
    this.endDate = date;
  }

  downloadLinkExcel() {
    if (this.startDate && this.endDate && this.startDate < this.endDate) {
      const messstNr = this.selectedMessstelle;
      const startDate = new Date(this.startDate); // Parse from yyyy-mm-dd to Date
      const endDate = new Date(this.endDate);

      const fromDate = `${startDate.getDate()}.${startDate.getMonth() +
        1}.${startDate.getFullYear()}`;
      const toDate = `${endDate.getDate()}.${endDate.getMonth() +
        1}.${endDate.getFullYear()}`;

      this.excelDownloadIsValid = true;

      return `https://restdienste.rlp-umwelt.de/aksamServiceTP/services/seenatlas/?mess_nr=${messstNr}&datum_von=${fromDate}&datum_bis=${toDate}&submit=Download&intern=false`;
    }
    this.excelDownloadIsValid = false;
    return "";
  }

  latestStartDate() {
    const today = new Date().toISOString().substr(0, 10);
    const endDate = this.endDate ? this.endDate : today;

    return endDate;
  }

  imageLink() {
    const messstellenFotoUrl =
      "https://fachdaten-wasser.rlp-umwelt.de/seenatlas/";

    const fotoQuery = "foto/";
    let see_nr = this.id;
    const fileType = ".jpg";

    if (see_nr.length < 3) {
      see_nr = "0" + see_nr;
    }
    see_nr = see_nr + "_1" + fileType;

    const link = messstellenFotoUrl + fotoQuery + see_nr;

    return link;
  }
}
